module.exports = __webpack_public_path__ + "media/images/landing-pages/nigel-b3730ba720b912a7e24608758e8c9fb9.png";